import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { useAppContext, useFreecodeContext } from 'hooks/useContext';
import { RectangleButton, ButtonsContainer } from 'components/Button/rectangleButton';
import { ApiContainer, PlusIcon } from './styles';
import ApiMethodDisplay from './ApiMethodDisplay';
import ResetImplementation from './ResetImplementation';
import ResetSolution from './ResetSolution';
import EditApiModal from './EditApiModal';
import { genChallengeMethodsFull, genSolutionMethodsFull } from './processApi';

const DefaultEditApiModalData = { isOpen: false, isImplimantation: false, apiMethod: {}, apiMethodIndex: -1 };

export default function FreecodeApiSettings() {
  const { isDarkMode } = useAppContext();
  const { testImpl } = useFreecodeContext();

  const [challengeApi, setChallengeApi] = useState([]);
  const [solutionApi, setsolutionApi] = useState([]);

  useEffect(() => {
    if (!testImpl?.api) return;
    setChallengeApi(genChallengeMethodsFull(testImpl.api, testImpl.generated?.apiStrings, 'python'));
    setsolutionApi(genSolutionMethodsFull(testImpl.api, testImpl.generated?.apiStrings, 'python'));
  }, [testImpl]);

  const [editApiModalData, setEditApiModalData] = useState(DefaultEditApiModalData);

  const openApiMethodModal = (isImplimantation = true, apiMethod = {}, apiMethodIndex = -1) => {
    setEditApiModalData({
      isOpen: true,
      isImplimantation: isImplimantation,
      apiMethod: apiMethod,
      apiMethodIndex: apiMethodIndex,
    });
  };

  const saveOrEditApiMethod = (apiMethod) => {
    // TODO save the new or updated api method
    console.log('should add/edit api method', apiMethod);
    toast.error('Saving api changes not implemented');
  };

  const regenerateSkeletons = () => {
    toast.error('Regenerate Skeletons Not implemented');
  };

  return (
    <ApiContainer isDarkMode={isDarkMode}>
      <ButtonsContainer>
        <RectangleButton small onClick={() => openApiMethodModal()}>
          <PlusIcon /> Add Implementation API
        </RectangleButton>
        <ResetImplementation />
      </ButtonsContainer>

      {challengeApi.map((apiMethod, index) => (
        <ApiMethodDisplay
          key={index}
          index={index}
          apiType="challenge"
          apiMethod={apiMethod}
          onClickEdit={() => openApiMethodModal(true, apiMethod, index)}
        />
      ))}

      <ButtonsContainer>
        <RectangleButton small onClick={() => openApiMethodModal(false)}>
          <PlusIcon /> Add Solution API
        </RectangleButton>
        <ResetSolution />
        <RectangleButton small floatRight marginRight onClick={regenerateSkeletons}>
          Regenerate Skeletons
        </RectangleButton>
      </ButtonsContainer>

      {solutionApi.map((apiMethod, index) => (
        <ApiMethodDisplay
          key={index}
          index={index}
          apiType="solution"
          apiMethod={apiMethod}
          onClickEdit={() => openApiMethodModal(false, apiMethod, index)}
        />
      ))}

      {/* Create or edit api modal */}
      {editApiModalData.isOpen && (
        <EditApiModal
          apiMethodToEdit={editApiModalData.apiMethod}
          onConfirm={saveOrEditApiMethod}
          closeModal={() => setEditApiModalData(DefaultEditApiModalData)}
        ></EditApiModal>
      )}
    </ApiContainer>
  );
}
